import React, { useEffect, useState } from "react";
import { FaUserTie, FaUniversity, FaStar, FaMobileAlt } from "react-icons/fa"; // Import relevant icons
import Moment from "react-moment";
import { defaultProfilePic } from "../../helpers/constantVariables";
import {
  MdOutlineLocationCity,
  MdOutlineLogin,
  MdOutlinePerson,
} from "react-icons/md";
import { navigateToPageInNewTab } from "../../services/reusable";
import { useObserver } from "mobx-react";

const UserDetailsCard = ({
  profilePic,
  name,
  email,
  role,
  designation,
  collegeName,
  skills,
  technicalScore,
  communicationScore,
  joinedAt,
  mobile,
  checkLogin,
  userId,
  city,
}) => {
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(false);

  useEffect(() => {
    const isLoggedIn = checkLogin;
    setIsUserLoggedIn(isLoggedIn);
  }, []);

  const navigateToLogin = () => {
    navigateToPageInNewTab("");
  };

  return useObserver(() => (
    <div className="bg-white shadow-lg rounded-lg p-4 my-8">
      <h2 className="text-xl gil-bold mb-4">About Candidate</h2>
      <div className="flex items-center mb-4">
        <img
          src={profilePic ?? defaultProfilePic}
          alt="User Profile"
          className="w-12 h-12 rounded-full mr-2"
        />
        <div>
          <h2 className="text-xl gil-bold mb-1">{name}</h2>
          <p
            className={`text-gray-500 text-xs ${
              isUserLoggedIn ? "block" : "blur"
            } `}
          >
            {email}
          </p>
        </div>
      </div>
      <div className="flex items-center mb-4">
        <FaUserTie className="mr-2 text-gray-500" />
        <p>
          <span className="gil-bold">Role:</span> {role}
        </p>
      </div>
      {/* <div className="flex items-center mb-4">
        <FaUserTie className="mr-2 text-gray-500" />
        <p>
          <span className="gil-bold">Designation:</span> {designation}
        </p>
      </div> */}
      <div className="flex items-center mb-4">
        <FaMobileAlt className="mr-2 text-gray-500" />
        <p className="flex items-center gap-1">
          <span className="gil-bold">Mobile:</span>{" "}
          <span className={`${isUserLoggedIn ? "block" : "blur"}`}>
            {mobile}
          </span>
        </p>
      </div>
      <div className="flex items-center mb-4">
        <FaUniversity className="mr-2 text-gray-500" />
        <p>
          <span className="gil-bold">College:</span> {collegeName ?? "N/A"}
        </p>
      </div>
      <div className="flex items-center mb-4">
        <FaStar className="mr-2 text-gray-500" />
        <p>
          <span className="gil-bold">Skills:</span> {skills.join(", ")}
        </p>
      </div>
      <div className="flex items-center mb-4">
        <FaStar className="mr-2 text-gray-500" />
        <p>
          <span className="gil-bold">Technical Score:</span> {technicalScore}%
        </p>
      </div>
      <div className="flex items-center mb-4">
        <FaStar className="mr-2 text-gray-500" />
        <p>
          <span className="gil-bold">Communication Score:</span>{" "}
          {communicationScore}%
        </p>
      </div>

      <div className="flex items-center mb-4">
        <MdOutlineLocationCity className="mr-2 text-gray-500" />
        <p>
          <span className="gil-bold">City:</span> {city ?? "N/A"}
        </p>
      </div>
      <div className="flex items-center mb-4">
        <MdOutlinePerson className="mr-2 text-gray-500" />
        <p>
          <span className="gil-bold">UserId:</span> {userId}
        </p>
      </div>

      <div className="flex items-center mb-4">
        <MdOutlineLogin className="mr-2 text-gray-500" />
        <p>
          <span className="gil-bold">Joined At:</span>{" "}
          <Moment format="MMMM D, YYYY">{joinedAt}</Moment>
        </p>
      </div>

      {!isUserLoggedIn && (
        <p className="text-yellow">
          Note:{" "}
          <span
            onClick={navigateToLogin}
            className="underline text-text_color3 cursor-pointer"
          >
            Login
          </span>{" "}
          as company to view the candidate details
        </p>
      )}
    </div>
  ));
};

export default UserDetailsCard;
